/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type ISuggestedChangesNotificationsQueryVariables = Types.Exact<{
  escrowId: Types.Scalars['ID']['input'];
}>;

export type ISuggestedChangesNotificationsQuery = {
  __typename?: 'Query';
  depositorSuggestedChanges: {
    __typename?: 'SuggestChangePage';
    nodesCount: number;
    nodes: Array<{
      __typename?: 'SuggestChange';
      id: string;
      partyStatus?: Types.SuggestedChangeStatusEnum | null;
      creatorType: Types.EscrowPartyTypeEnum;
      receiverType?: Types.EscrowPartyTypeEnum | null;
    }>;
  };
  beneficiarySuggestedChanges: {
    __typename?: 'SuggestChangePage';
    nodesCount: number;
    nodes: Array<{
      __typename?: 'SuggestChange';
      id: string;
      partyStatus?: Types.SuggestedChangeStatusEnum | null;
      creatorType: Types.EscrowPartyTypeEnum;
      receiverType?: Types.EscrowPartyTypeEnum | null;
    }>;
  };
  notificationSuggestedChanges: {
    __typename?: 'SuggestChangePage';
    nodesCount: number;
    nodes: Array<{
      __typename?: 'SuggestChange';
      id: string;
      partyStatus?: Types.SuggestedChangeStatusEnum | null;
      creatorType: Types.EscrowPartyTypeEnum;
      receiverType?: Types.EscrowPartyTypeEnum | null;
    }>;
  };
  depositSuggestedChanges: {
    __typename?: 'SuggestChangePage';
    nodesCount: number;
    nodes: Array<{
      __typename?: 'SuggestChange';
      id: string;
      partyStatus?: Types.SuggestedChangeStatusEnum | null;
      creatorType: Types.EscrowPartyTypeEnum;
      receiverType?: Types.EscrowPartyTypeEnum | null;
    }>;
  };
  agreementSuggestedChanges: {
    __typename?: 'SuggestChangePage';
    nodesCount: number;
    nodes: Array<{
      __typename?: 'SuggestChange';
      id: string;
      partyStatus?: Types.SuggestedChangeStatusEnum | null;
      creatorType: Types.EscrowPartyTypeEnum;
      receiverType?: Types.EscrowPartyTypeEnum | null;
    }>;
  };
  environmentSuggestedChanges: {
    __typename?: 'SuggestChangePage';
    nodesCount: number;
    nodes: Array<{
      __typename?: 'SuggestChange';
      id: string;
      partyStatus?: Types.SuggestedChangeStatusEnum | null;
      creatorType: Types.EscrowPartyTypeEnum;
      receiverType?: Types.EscrowPartyTypeEnum | null;
    }>;
  };
};

export const SuggestedChangesNotificationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'suggestedChangesNotifications' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'escrowId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'depositorSuggestedChanges' },
            name: { kind: 'Name', value: 'suggestedChanges' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'escrowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'escrowId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'pending' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'changeType' },
                value: { kind: 'EnumValue', value: 'DepositorSuggestedChange' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'nodesCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'partyStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'creatorType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'receiverType' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'beneficiarySuggestedChanges' },
            name: { kind: 'Name', value: 'suggestedChanges' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'escrowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'escrowId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'pending' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'changeType' },
                value: { kind: 'EnumValue', value: 'BeneficiarySuggestedChange' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'nodesCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'partyStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'creatorType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'receiverType' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'notificationSuggestedChanges' },
            name: { kind: 'Name', value: 'suggestedChanges' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'escrowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'escrowId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'pending' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'changeType' },
                value: { kind: 'EnumValue', value: 'NotificationSuggestedChange' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'nodesCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'partyStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'creatorType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'receiverType' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'depositSuggestedChanges' },
            name: { kind: 'Name', value: 'suggestedChanges' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'escrowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'escrowId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'pending' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'changeType' },
                value: { kind: 'EnumValue', value: 'DepositSuggestedChange' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'nodesCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'partyStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'creatorType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'receiverType' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'agreementSuggestedChanges' },
            name: { kind: 'Name', value: 'suggestedChanges' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'escrowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'escrowId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'pending' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'changeType' },
                value: { kind: 'EnumValue', value: 'AgreementSuggestedChange' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'nodesCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'partyStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'creatorType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'receiverType' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'environmentSuggestedChanges' },
            name: { kind: 'Name', value: 'suggestedChanges' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'escrowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'escrowId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'pending' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'changeType' },
                value: { kind: 'EnumValue', value: 'EnvironmentSuggestedChange' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'nodesCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'partyStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'creatorType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'receiverType' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ISuggestedChangesNotificationsQuery, ISuggestedChangesNotificationsQueryVariables>;
